import React from 'react';

/**
 * Literal presentation primitives extracted from the approved CyberTech More Info page.
 *
 * Keep the ctmi class contract here. CyberTech and every shared More Info destination
 * consume the same heading, picture and cinematic-media grammar instead of maintaining
 * look-alike implementations.
 */
export function MoreInfoHeading({ eyebrow, title, children, light = false }) {
  return (
    <header className={`ctmi-heading${light ? ' ctmi-heading--light' : ''}`}>
      <span>{eyebrow}</span><h2>{title}</h2>{children ? <p>{children}</p> : null}
    </header>
  );
}

export function MoreInfoPicture({ src, alt, caption, position = 'center', fit = 'cover', className = '' }) {
  return (
    <figure className={`ctmi-picture ${className}`.trim()}>
      <img src={src} alt={alt} loading="eager" style={{ objectPosition: position, objectFit: fit }} />
      {caption ? <figcaption>{caption}</figcaption> : null}
    </figure>
  );
}

export function MoreInfoCinema({ src, alt, eyebrow, title, copy, items = [], className = '' }) {
  return (
    <section className={`ctmi-cinema ${className}`.trim()}>
      <img src={src} loading="eager" alt={alt} />
      <div className="ctmi-cinema__shade" />
      <div className="ctmi-shell ctmi-cinema__copy">
        {eyebrow ? <span className="ctmi-kicker">{eyebrow}</span> : null}
        <h2>{title}</h2>
        {copy ? <p>{copy}</p> : null}
        {items.length ? <div className="ctmi-readout">{items.map((item) => <span key={item.label || item}><small>{item.label || 'Capability'}</small><b>{item.value || item}</b></span>)}</div> : null}
      </div>
    </section>
  );
}
